<template>
  <header class="order-info-tile c:row-between-center">
    <div class="order-info-tile-label">{{ label }}</div>
    <div class="order-info-tile-value">{{ valueText }}</div>
  </header>
</template>
<script>
import { outputmoney } from "@/utils";

export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    valueText() {
      switch (this.type) {
        case "amount":
          return `¥ ${outputmoney(this.value)}`;

        default:
          return this.value;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.order-info-tile {
  padding: 14/20rem 0;
  border-bottom: 1/20rem solid #e4e4e4;
  color: #000000;

  &-label {
    height: 20/20rem;
    line-height: 20/20rem;
    font-size: 14/20rem;
    font-weight: 400;
    letter-spacing: 0;
  }

  &-value {
    height: 21/20rem;
    line-height: 21/20rem;
    font-size: 14/20rem;
    font-weight: 500;
    letter-spacing: 0;
  }
}
</style>
